import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSupportinline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M19.56 7.119a9 9 0 0 1 .001 9.763M15.548 8.452a5.017 5.017 0 1 1-7.096 7.096 5.017 5.017 0 0 1 7.096-7.096"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "m14.321 7.551 2.584-3.139a1.003 1.003 0 0 1 1.483-.072l1.273 1.273a1 1 0 0 1-.072 1.483L16.45 9.68M9.679 16.449l-2.584 3.139a1.003 1.003 0 0 1-1.483.072l-1.273-1.273a1 1 0 0 1 .072-1.483L7.55 14.32M7.551 9.679l-3.14-2.584a1.003 1.003 0 0 1-.072-1.483l1.273-1.273a1 1 0 0 1 1.483.072L9.679 7.55M16.449 14.321l3.139 2.584c.457.376.49 1.064.072 1.483l-1.273 1.273a1 1 0 0 1-1.483-.072L14.32 16.45"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M16.882 19.561a9 9 0 0 1-9.763-.001M4.439 7.118a9 9 0 0 0 .001 9.763M16.881 4.44a9 9 0 0 0-9.763-.001"
		})
	]
});
export default SvgSupportinline;
